var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13135 4.19995L5.76566 1.56564C6.07808 1.25322 6.07808 0.746685 5.76566 0.434266C5.45324 0.121846 4.94671 0.121846 4.63429 0.434266L0.63429 4.43427C0.32187 4.74669 0.32187 5.25322 0.63429 5.56564L4.63429 9.56564C4.94671 9.87806 5.45324 9.87806 5.76566 9.56564C6.07808 9.25322 6.07808 8.74669 5.76566 8.43427L3.13135 5.79995H10.8C11.2418 5.79995 11.6 5.44178 11.6 4.99995C11.6 4.55812 11.2418 4.19995 10.8 4.19995H3.13135Z",
    fill: "#0B24FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_192",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13135 4.19995L5.76566 1.56564C6.07808 1.25322 6.07808 0.746685 5.76566 0.434266C5.45324 0.121846 4.94671 0.121846 4.63429 0.434266L0.63429 4.43427C0.32187 4.74669 0.32187 5.25322 0.63429 5.56564L4.63429 9.56564C4.94671 9.87806 5.45324 9.87806 5.76566 9.56564C6.07808 9.25322 6.07808 8.74669 5.76566 8.43427L3.13135 5.79995H10.8C11.2418 5.79995 11.6 5.44178 11.6 4.99995C11.6 4.55812 11.2418 4.19995 10.8 4.19995H3.13135Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_192)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrev);
export default __webpack_public_path__ + "static/media/icon-prev.f540115693021529ac6c5a06df678f39.svg";
export { ForwardRef as ReactComponent };